export const getNavigatorLocale = () => {
  return navigator.languages?.[0] ?? navigator.language
}
